import Markdown from 'markdown-to-jsx'

interface Props {
  children: string
}

/**
 * Renders AI-produced markdown (headings, paragraphs, bold, italic, lists)
 * into the Yadviga visual style — sage tones, serif headings, generous line
 * height. Used for tarot interpretations, natal chart prose, etc.
 *
 * Why a parser at all: the model is asked to output `### Heading` style
 * sections; without a parser those literally render as `### Heading` text.
 */
export function MarkdownText({ children }: Props) {
  return (
    <Markdown
      options={{
        forceBlock: true,
        overrides: {
          h1: { props: { className: 'mt-4 first:mt-0 mb-2 font-serif text-xl text-sage-800' } },
          h2: { props: { className: 'mt-4 first:mt-0 mb-2 font-serif text-lg text-sage-800' } },
          h3: { props: { className: 'mt-4 first:mt-0 mb-2 font-serif text-lg text-sage-800' } },
          h4: { props: { className: 'mt-3 first:mt-0 mb-1 font-serif text-base text-sage-800' } },
          p:  { props: { className: 'my-2 leading-relaxed text-sage-800' } },
          strong: { props: { className: 'font-semibold text-sage-900' } },
          em: { props: { className: 'italic text-sage-700' } },
          ul: { props: { className: 'my-2 list-disc pl-5 text-sage-800' } },
          ol: { props: { className: 'my-2 list-decimal pl-5 text-sage-800' } },
          li: { props: { className: 'my-1 leading-relaxed' } },
          blockquote: {
            props: { className: 'my-3 border-l-2 border-copper/50 pl-3 italic text-sage-700' },
          },
          hr: { props: { className: 'my-4 border-sage-200' } },
          a: { props: { className: 'text-copper underline' } },
        },
      }}
    >
      {children}
    </Markdown>
  )
}
